module.exports = __webpack_public_path__ + "img/signature-purple.01904bbc.svg";